import { fetchIn, saveIn } from 'GrooveLocalStorage';
import createLocalStoreCheckedLabelsPath from 'Modules/Shared/utilities/createLocalStoreCheckedLabelsPath';

const get = moduleName => {
  const keyPath = createLocalStoreCheckedLabelsPath(moduleName);
  return fetchIn(keyPath);
};

const set = ({ moduleName, ids }) => {
  const keyPath = createLocalStoreCheckedLabelsPath(moduleName);
  saveIn(keyPath, ids.toJS());
};

export { get, set };
